import React, { useState } from "react";

const PreviewChat = () => {
    const [showchart, setshowchart] = useState(false)
    return (
        showchart ?
            <div className="chatBoxImageClass active" >
                <div className="chartbotcloseicons" onClick={() => setshowchart(false)}>
                    <img src="https://chatagent.pranathiss.com/img/minimizeIcon/minimize1.png" alt="Line" />
                </div>
                <iframe id="myFrame" src="http://localhost:3000/gAAAAABnvE4yKt7Rx0nFw-lubz21czGNa1qvUa1z8Ao8uPwDg69EqYRoLWy1CAEL5JxI71Fcja3kYzUaHtv1RPieW9cKCo929Q==/gAAAAABnvE4ySu1DVnj_goEEBjSHeMyr9_lv-tx2TecnE2DjwCDGXkcKFda49QAcnpZh6medl6rcPl54BhRhkjwiOehGIW9Oww==/home/aubrey/" style={{ width: "100%", height: "100vh" }} allow="camera; microphone" sandbox="allow-same-origin allow-scripts allow-forms allow-modals allow-popups"></iframe>
            </div> :
            <div className="">
                <div class=" chatBoxImageClass" onClick={() => setshowchart(true)}>
                    <img src="https://chatagent.pranathiss.com/aubrey.91bd0c4e.jpg" alt="" />
                </div>
            </div>

    )
}

export default PreviewChat